export interface VideoItem {
  id: string;
  title: string;
  category: string;
  cover: string;
  duration: string;
  views: string;
  heat: number;
  tags: string[];
  desc: string;
  date: string;
}

export interface CategoryItem {
  id: string;
  name: string;
  desc: string;
  cover: string;
  count: number;
}

export const categories: CategoryItem[] = [
  {
    id: "mingxing",
    name: "明星八卦",
    desc: "一线明星动态与圈内新鲜事，一手吃瓜现场",
    cover: "https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20spotlight%20moment%20with%20warm%20golden%20lights%20and%20celebrities%20silhouettes%2C%20paparazzi%20flash%20photography%2C%20cinematic%20editorial%20style%2C%20warm%20coral%20and%20gold%20tone%2C%20vibrant%20energetic%20entertainment%20atmosphere%2C%20high%20detail&width=800&height=560&seq=gua-cat-01&orientation=landscape",
    count: 328,
  },
  {
    id: "zongyi",
    name: "综艺名场面",
    desc: "热门综艺高能片段与嘉宾互动名场面合集",
    cover: "https://readdy.ai/api/search-image?query=bright%20studio%20show%20set%20with%20colorful%20stage%20lights%20and%20hosts%20having%20fun%2C%20variety%20show%20entertainment%20program%2C%20warm%20orange%20and%20yellow%20lighting%2C%20lively%20playful%20atmosphere%2C%20cinematic%20television%20production%20style%2C%20high%20energy&width=800&height=560&seq=gua-cat-02&orientation=landscape",
    count: 214,
  },
  {
    id: "resou",
    name: "热搜盘点",
    desc: "每日热搜话题深度盘点与事件时间线梳理",
    cover: "https://readdy.ai/api/search-image?query=trending%20news%20wall%20with%20glowing%20headline%20boards%20and%20search%20bubbles%2C%20social%20media%20trend%20concept%2C%20warm%20amber%20and%20coral%20neon%20glow%2C%20modern%20digital%20collage%2C%20vibrant%20informative%20atmosphere%2C%20cinematic%20style&width=800&height=560&seq=gua-cat-03&orientation=landscape",
    count: 176,
  },
  {
    id: "hongtan",
    name: "红毯现场",
    desc: "各大盛典红毯造型盘点与高光时刻直击",
    cover: "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20event%20night%20with%20spotlights%20and%20photographers%2C%20glamorous%20award%20ceremony%2C%20warm%20golden%20and%20crimson%20lighting%2C%20luxurious%20cinematic%20atmosphere%2C%20high%20detail%20editorial%20photography&width=800&height=560&seq=gua-cat-04&orientation=landscape",
    count: 142,
  },
  {
    id: "yinyue",
    name: "音乐现场",
    desc: "演唱会与舞台表演名场面，live 高能直拍",
    cover: "https://readdy.ai/api/search-image?query=concert%20stage%20performance%20with%20crowd%20and%20colorful%20laser%20lights%2C%20live%20music%20show%2C%20warm%20orange%20and%20magenta%20stage%20lighting%2C%20energetic%20festival%20atmosphere%2C%20cinematic%20night%20concert%20photography%2C%20high%20detail&width=800&height=560&seq=gua-cat-05&orientation=landscape",
    count: 198,
  },
  {
    id: "quannei",
    name: "圈内秘闻",
    desc: "娱乐圈深度解读与幕后故事，理性吃瓜观察",
    cover: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20film%20studio%20with%20cameras%20and%20softbox%20lights%2C%20mysterious%20dim%20room%20with%20warm%20glow%2C%20entertainment%20industry%20insider%20concept%2C%20cinematic%20storytelling%20atmosphere%2C%20warm%20tones&width=800&height=560&seq=gua-cat-06&orientation=landscape",
    count: 167,
  },
];

export const hotVideos: VideoItem[] = [
  {
    id: "v-1001",
    title: "年度红毯名场面：众星云集同台斗艳全记录",
    category: "hongtan",
    cover: "https://readdy.ai/api/search-image?query=grand%20award%20ceremony%20red%20carpet%20with%20multiple%20celebrities%20in%20elegant%20evening%20gowns%2C%20golden%20spotlights%20and%20camera%20flashes%2C%20glamorous%20gala%20night%2C%20warm%20crimson%20and%20gold%20palette%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=900&height=560&seq=gua-hot-01&orientation=landscape",
    duration: "18:42",
    views: "1203.6万",
    heat: 98,
    tags: ["红毯", "盛典", "明星穿搭"],
    desc: "一年一度的颁奖盛典红毯环节全记录，从开场的重磅嘉宾到压轴登场的流量担当，每个瞬间都值得反复回味。本合集串联红毯走秀、后台花絮与采访名场面，带你一次看全年度最高能的红毯现场。",
    date: "2026-08-16",
  },
  {
    id: "v-1002",
    title: "综艺高能反转名场面，笑到停不下来的现场",
    category: "zongyi",
    cover: "https://readdy.ai/api/search-image?query=exciting%20game%20show%20moment%20with%20hosts%20laughing%20and%20colorful%20confetti%2C%20bright%20studio%20lights%2C%20fun%20variety%20program%20energy%2C%20warm%20orange%20and%20yellow%20tone%2C%20cinematic%20television%20style%2C%20joyful%20atmosphere&width=900&height=560&seq=gua-hot-02&orientation=landscape",
    duration: "23:15",
    views: "986.4万",
    heat: 96,
    tags: ["综艺", "名场面", "爆笑"],
    desc: "最新一期热门综艺的神级反转片段全汇总，从游戏环节的突发状况到嘉宾之间的神仙互动，高能不断。这些片段在社交平台刷屏不是没有原因的，看完你就懂为什么大家都在安利这档节目。",
    date: "2026-08-15",
  },
  {
    id: "v-1003",
    title: "热搜第一事件完整时间线，全网围观全过程",
    category: "resou",
    cover: "https://readdy.ai/api/search-image?query=breaking%20news%20timeline%20infographic%20with%20glowing%20number%20one%20ranking%2C%20hot%20search%20topic%20concept%2C%20warm%20amber%20neon%20glow%2C%20modern%20digital%20collage%2C%20cinematic%20informative%20style&width=900&height=560&seq=gua-hot-03&orientation=landscape",
    duration: "12:08",
    views: "1587.9万",
    heat: 99,
    tags: ["热搜", "事件盘点", "时间线"],
    desc: "从事件的源头到后续发酵，完整梳理这条冲上热搜第一的大事件。我们把各方回应、时间节点和网友讨论集中整理成一条清晰的时间线，理性吃瓜不迷路，一次看懂事情全貌。",
    date: "2026-08-16",
  },
  {
    id: "v-1004",
    title: "演唱会高能现场：万人合唱氛围拉满",
    category: "yinyue",
    cover: "https://readdy.ai/api/search-image?query=arena%20concert%20with%20massive%20crowd%20singing%20and%20phone%20flashlights%2C%20singer%20on%20stage%20with%20laser%20lights%2C%20warm%20orange%20and%20magenta%20lighting%2C%20emotional%20live%20music%20atmosphere%2C%20cinematic%20night%20concert%20photography&width=900&height=560&seq=gua-hot-04&orientation=landscape",
    duration: "09:36",
    views: "754.2万",
    heat: 92,
    tags: ["演唱会", "live", "大合唱"],
    desc: "当全场数万观众同时亮起手机闪光灯，合唱声浪几乎掀翻屋顶，这就是现场音乐无可替代的魅力。这段高能直拍带你身临其境感受万人合唱的震撼氛围，看完只想立刻买票去看下一场。",
    date: "2026-08-14",
  },
];

export const allVideos: VideoItem[] = [
  ...hotVideos,
  {
    id: "v-1005",
    title: "新剧开播引爆话题，角色争议成全网热议焦点",
    category: "resou",
    cover: "https://readdy.ai/api/search-image?query=dramatic%20tv%20series%20scene%20with%20moody%20character%20close%20up%2C%20film%20stills%20aesthetic%2C%20warm%20amber%20and%20coral%20cinematic%20lighting%2C%20emotional%20drama%20atmosphere%2C%20high%20detail&width=900&height=560&seq=gua-v-05&orientation=landscape",
    duration: "15:20",
    views: "689.1万",
    heat: 90,
    tags: ["影视", "开播", "热议"],
    desc: "新剧首播即冲上话题榜，剧中角色的塑造与剧情走向引发观众激烈讨论。本期带你梳理开播以来的高光片段与网友两极评价，理性分析这部剧为何能引爆全网热议。",
    date: "2026-08-13",
  },
  {
    id: "v-1006",
    title: "圈内新晋顶流盘点：从新人到爆红的成长轨迹",
    category: "quannei",
    cover: "https://readdy.ai/api/search-image?query=rising%20star%20journey%20collage%20with%20spotlight%20on%20stage%2C%20breakthrough%20artist%20concept%2C%20warm%20golden%20rays%20and%20coral%20accents%2C%20cinematic%20editorial%20style%2C%20inspiring%20atmosphere&width=900&height=560&seq=gua-v-06&orientation=landscape",
    duration: "20:45",
    views: "512.8万",
    heat: 87,
    tags: ["顶流", "成长", "盘点"],
    desc: "从默默无闻到一炮而红，新晋顶流的成长轨迹盘点。本视频梳理他们出道的关键节点、代表作与路人缘转变，看一颗新星如何一步步走进大众视野。",
    date: "2026-08-12",
  },
  {
    id: "v-1007",
    title: "颁奖典礼后台花絮：镜头后的真实瞬间",
    category: "quannei",
    cover: "https://readdy.ai/api/search-image?query=backstage%20award%20show%20behind%20the%20scenes%20with%20artists%20relaxing%2C%20makeup%20room%20and%20green%20room%2C%20warm%20dim%20lighting%20with%20golden%20glow%2C%20candid%20documentary%20style%2C%20cinematic&width=900&height=560&seq=gua-v-07&orientation=landscape",
    duration: "11:55",
    views: "423.9万",
    heat: 84,
    tags: ["后台", "花絮", "真实"],
    desc: "聚光灯之外的典礼后台是什么样子？本期镜头跟拍颁奖典礼后台的真实瞬间，从紧张备稿到台上台下判若两人的反转，带你看见明星不为人知的一面。",
    date: "2026-08-11",
  },
  {
    id: "v-1008",
    title: "实力歌手 live 直拍，嗓音质感炸裂全场",
    category: "yinyue",
    cover: "https://readdy.ai/api/search-image?query=powerful%20singer%20performing%20live%20on%20stage%20with%20dynamic%20backlight%2C%20emotive%20vocal%20performance%2C%20warm%20orange%20spotlight%2C%20cinematic%20music%20stage%20photography%2C%20high%20energy&width=900&height=560&seq=gua-v-08&orientation=landscape",
    duration: "07:42",
    views: "356.3万",
    heat: 81,
    tags: ["live", "歌手", "直拍"],
    desc: "高能实力派歌手的现场直拍来了，从低音共鸣到高音爆发，稳到不行的嗓音质感直接炸裂全场。这段无修音现场完美展现了真正的唱功，值得反复循环。",
    date: "2026-08-10",
  },
  {
    id: "v-1009",
    title: "大牌合作官宣，粉丝狂欢瞬间刷屏",
    category: "mingxing",
    cover: "https://readdy.ai/api/search-image?query=exciting%20brand%20collaboration%20announcement%20with%20confetti%20and%20golden%20sparkle%2C%20celebrity%20endorsement%20concept%2C%20warm%20gold%20and%20coral%20tone%2C%20festive%20vibrant%20atmosphere%2C%20cinematic%20commercial%20style&width=900&height=560&seq=gua-v-09&orientation=landscape",
    duration: "05:18",
    views: "612.4万",
    heat: 88,
    tags: ["官宣", "合作", "粉丝"],
    desc: "两位人气明星的梦幻联动正式官宣，消息一出粉丝立刻炸开锅，社交平台瞬间刷屏。本期盘点官宣现场的高能细节与网友的千层反应，看看这波联动为何如此受期待。",
    date: "2026-08-09",
  },
  {
    id: "v-1010",
    title: "综艺名场面合集：这些片段值得反复观看",
    category: "zongyi",
    cover: "https://readdy.ai/api/search-image?query=compilation%20of%20fun%20variety%20show%20moments%20with%20playful%20hosts%2C%20bright%20studio%20set%20and%20colorful%20props%2C%20warm%20yellow%20and%20orange%20lighting%2C%20lively%20comedic%20atmosphere%2C%20cinematic&width=900&height=560&seq=gua-v-10&orientation=landscape",
    duration: "28:33",
    views: "298.5万",
    heat: 79,
    tags: ["合集", "综艺", "名场面"],
    desc: "一网打尽近期综艺的高能名场面，从爆笑互怼到感人瞬间全部收录。无论你是综艺爱好者还是偶尔刷到片段的路人，这份合集都能让你一次看个够。",
    date: "2026-08-08",
  },
  {
    id: "v-1011",
    title: "红毯造型盘点：谁穿出了今年最佳战袍",
    category: "hongtan",
    cover: "https://readdy.ai/api/search-image?query=fashion%20red%20carpet%20look%20roundup%20with%20elegant%20evening%20dresses%2C%20designer%20gowns%20collection%2C%20warm%20golden%20and%20crimson%20backdrop%2C%20glamorous%20editorial%20fashion%20photography%2C%20high%20detail&width=900&height=560&seq=gua-v-11&orientation=landscape",
    duration: "14:09",
    views: "487.6万",
    heat: 86,
    tags: ["穿搭", "造型", "盘点"],
    desc: "今年各大红毯的造型都在这里，从高定礼服到大胆新意造型逐一盘点。专业视角点评剪裁、配色与整体气场，看看哪位明星穿出了你心中的最佳战袍。",
    date: "2026-08-07",
  },
  {
    id: "v-1012",
    title: "近期吃瓜速报：一周热点一网打尽",
    category: "resou",
    cover: "https://readdy.ai/api/search-image?query=weekly%20gossip%20news%20roundup%20with%20newspaper%20style%20collage%20and%20hot%20topic%20badges%2C%20warm%20amber%20and%20coral%20accents%2C%20modern%20editorial%20design%2C%20informative%20cinematic%20atmosphere&width=900&height=560&seq=gua-v-12&orientation=landscape",
    duration: "19:27",
    views: "356.7万",
    heat: 82,
    tags: ["速报", "周报", "热点"],
    desc: "一周热点一网打尽的吃瓜速报来了，从娱乐大事件到社会热议话题全部梳理清楚。省去翻找的麻烦，一条视频带你看完这一周值得关注的所有内容。",
    date: "2026-08-06",
  },
];